export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"16\" fill=\"#C9CBD4\" stroke=\"#fff\" stroke-width=\"4\"/><path d=\"M17.475 21.253h1.05v-2.1h2.1v-1.05h-2.1v-2.1h-1.05v2.1h-2.1v1.05h2.1v2.1zM12.05 24c-.28 0-.525-.105-.735-.315A1.007 1.007 0 0111 22.95v-9.1c0-.28.105-.525.315-.735.21-.21.455-.315.735-.315h3.15v-1.75c0-.28.105-.525.315-.735.21-.21.455-.315.735-.315h3.5c.28 0 .525.105.735.315.21.21.315.455.315.735v1.75h3.15c.28 0 .525.105.735.315.21.21.315.455.315.735v9.1c0 .28-.105.525-.315.735-.21.21-.455.315-.735.315h-11.9zm4.2-11.2h3.5v-1.75h-3.5v1.75z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};